import { Component, Input } from '@angular/core';

import { isStatusPretendidoNaoPretendido, isStatusPretendidoPretendido, isStatusPretendidoPotencial, isStatusPretendidoRealizado } from '../cliente-analise-mercado-status-pretendido';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-pretendido-badge-pill',
    templateUrl: './cliente-analise-mercado-status-pretendido-badge-pill.component.html',
    styleUrls: ['./cliente-analise-mercado-status-pretendido-badge-pill.component.less']
})
export class ClienteAnaliseMercadoStatusPretendidoBadgePillComponent {
    /** Status pretendido da análise de mercado */
    @Input() statusPretendido: number;
    /** Title para exibir no badge */
    @Input() title: string = null;

    /** Verifica se é o status Não Pretendido */
    isNaoPretendido(): boolean {
        return isStatusPretendidoNaoPretendido(this.statusPretendido);
    }

    /** Verifica se é o status Pretendido */
    isPretendido(): boolean {
        return isStatusPretendidoPretendido(this.statusPretendido);
    }

    /** Verifica se é o status Potencial */
    isPotencial(): boolean {
        return isStatusPretendidoPotencial(this.statusPretendido);
    }

    /** Verifica se é o status Realizado */
    isRealizado(): boolean {
        return isStatusPretendidoRealizado(this.statusPretendido);
    }
}
